
// 1：如果没报名显示 “立即报名”，
// 2： 已报名未开始考试的显示“已报名“
// 3：已报名开始考试的 显示 “开始答题”（练习类型）、“立即考试”（考试类型）
// 4： 已报名考试完的显示“已考试” 多次考试的，已考过的都统一显示“已考试”
//获取用户与考试的状态 examObj：考试对象，userJoinList：用户已报名的考试列表
const  getUserExamType = function (examObj,userJoinList) {
    let stateObj={
        name:"",
        type:null,
        userAnswerTimes:0,//已考次数
    }
    if(examObj.typeLabel == "1"){
        //if(examObj.signin){//需要报名的考试，去报名列表里查找是否报名，如果未报名返回“立即报名”，如果已报名未开始考试返回“已报名”，如果已开始考试返回“立即考试”
            let isJoin= false;//用户是否已报名
            let isStartExam = false;//是否已开始考试
            let startTime = new Date(examObj.startTime);
            let today = new Date();
            if(startTime.getTime() < today.getTime()){
                isStartExam = true;
            }
            let isFind=false;
            if(!examObj.examId){ //容错处理
                examObj.examId = examObj.id?examObj.id:0;
            }
            for(let i=0;i<userJoinList.length;i++){
                let item =userJoinList[i]; 
                if(item.examId == examObj.examId){ //找到考试报名信息 

                    if(item.userAnswerTimes >=examObj.answerTimes){
                        stateObj.name="已考试";
                        stateObj.type=12 
                     } 
                     else {  
                        stateObj.name="立即考试";
                        stateObj.type=11
                     }
                     stateObj.userAnswerTimes = item.userAnswerTimes;
                    isFind= true;
                    break; 
                }
            }
            if(!isFind ){//未找到考试报名信息
                if(examObj.signin == true){ //需要报名
                    stateObj.name="立即报名";
                    stateObj.type=10;
                } else{ //不需要报名
                    stateObj.name="立即考试";
                    stateObj.type=11 
                }
               
            }
           
        // }else { //不需要报名
        //     stateObj.name="立即考试";
        //     stateObj.type=11 
        // }
    }else { //练习 
        
        stateObj.name="开始答题";
        stateObj.type=20 
    }
    return stateObj;
}
const  formatDate = function(date, fmt) {
    if (date == null) {
      return "";
    }
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "M+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "m+": date.getMinutes().toString(),         // 分
      "s+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
    };
    return fmt;
  }
 

// 切换全屏模式
const enterFullScreen = () => {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    // 兼容 Firefox
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    // 兼容 Chrome, Safari 和 Opera
    element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) {
    // 兼容 IE/Edge
    element.msRequestFullscreen()
  }
};

export {
    getUserExamType,
    formatDate,
    enterFullScreen
};



// WEBPACK FOOTER //
// ./src/utils/common.js